import React from 'react';
import { Form } from 'react-bootstrap';
import { OutputTextLine } from '../Output/OutputTextLine';

export function InfoText(props) {
    const { label, description } = props;
    return (
        <>
            <Form.Label className="m-0 mt-4 position-relative">
                <span className="font-weight-bold">{label}</span>
            </Form.Label>
            <hr className="mt-0 mb-2" />
            <div className="small">
                {description &&
                    description
                        .split('\n')
                        .map((line) => line.replace(/\r/g, ''))
                        .map((line, i) => (
                            <React.Fragment key={i}>
                                <OutputTextLine textLine={line} />
                            </React.Fragment>
                        ))}
            </div>
        </>
    );
}
